<template>
  <tr>

    <td>
      <div class="action-buttons">
      <button class="button"
              @click="editLocation"
              :disabled="isDeleting"
              title="Edit location">
        <font-awesome-icon icon="edit" />
      </button>

      <button class="button is-warning"
              :disabled="isDeleting"
              :class="{ 'is-loading': isDeleting }"
              @click="removeLocation"
              title="Delete location">
        <font-awesome-icon icon="trash-alt" />
      </button>
      </div>
    </td>
    <td> {{ address.facilityName }} </td>
    <td>
      {{ address.city }}, {{ address.state }}
      <br/>
      <span class="is-size-7">{{ address.street1 }}</span>
    </td>
    <td class="cell-dock">
      {{ location.companyJobPointDock }}
    </td>
    <td>
      <div v-if="hasContacts" class="contacts">
        <template v-if="location.CompanyRolodexContactKey1">
          {{ location.CompanyRolodexContactKey1.companyRolodexContactFullName }}
        </template>
        <template v-if="location.CompanyRolodexContactKey2">
          <br/>
          {{ location.CompanyRolodexContactKey2.companyRolodexContactFullName }}
        </template>
      </div>

    </td>
    <td>
      {{ formattedDate }}
      <br/>
      <span class="is-size-7">{{ formattedTime }}</span>
    </td>
  </tr>
</template>

<script>
import CompanyJobApi from '@/api-interface/companyjob'
import { isEmpty } from 'lodash-es'
import { format } from 'date-fns'

export default {
  name: 'LocationPicker-row',

  model: {
    prop: 'location',
    event: 'change'
  },

  props: {
    location: {
      type: Object
    }
  },

  data() {
    return {
      isDeleting: false
    }
  },

  computed: {
    formattedDate() {
      const dateFormat = 'MMM DD, YYYY'

      const earliestDate = format(this.location.companyJobPointDateEarliest, dateFormat)
      const latestDate = format(this.location.companyJobPointDateLatest, dateFormat)

      let date = earliestDate
      if (earliestDate !== latestDate) {
        date = `${earliestDate} - ${latestDate}`
      }

      return date
    },

    formattedTime() {
      const timeFormat = 'hh:mm A'

      const earliestTime = format(this.location.companyJobPointDateEarliest, timeFormat)
      const latestTime = format(this.location.companyJobPointDateLatest, timeFormat)

      return `between ${earliestTime} - ${latestTime}`
    },

    address() {
      return this.location.address ? this.location.address : {}
    },

    hasContacts() {
      return !isEmpty(this.location.CompanyRolodexContactKey1) || !isEmpty(this.location.CompanyRolodexContactKey2)
    }
  },

  methods: {
    async removeLocation() {
      // for jobPoints that have already been saved... we need to call a different endpoint to delete them
      if (this.location.companyJobPointKey) {
        this.isDeleting = true
        await CompanyJobApi.deleteJobPoint(this.location.companyJobPointKey)
        this.isDeleting = false
      }

      this.$emit('delete', this.location)
    },

    editLocation() {
      this.$emit('edit', this.location)
    }
  }
}
</script>

<style scoped lang="scss">
.cell-dock {
  width: 100px;
}

.action-buttons {
  display: flex;
  justify-content: space-evenly;
}
</style>
